<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" :class="{'header-fixed': isFixed}">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="info-icon"><i class="glyphicon glyphicon-earphone"></i></span>{{ contactUs.telephone }}
          <span class="info-icon"><i class="glyphicon glyphicon-envelope"></i></span>{{ contactUs.customerEmail }}
          <span class="info-icon"><i class="glyphicon glyphicon-time"></i></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span><router-link to="/contactus">赶快联系我们吧！</router-link>
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/nylogo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/nylogo.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <div class="hamburger" :class="{ 'is-active': menuActive }">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </div>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {contactUsList} from '@/api/api'
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      menuActive: false,
      isFixed: false,
      contactUs:{},
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "关于我们",
          path: "/software",
          children: [
            {
              name: "企业介绍",
              path: "/software/smartTown"
            },
            {
              name: "发展历程",
              path: "/software/bigData"
            },
            {
              name: "企业荣誉以及资质",
              path: "/software/honor"
            }
          ]
        },
        {
          name: "公司业务",
          path: "/service",
          children: []
        },
        {
          name: "新闻动态",
          path: "/newsinformation",
          children: []
        },
        {
          name: "人才招聘",
          path: "/jobchance",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.initContactUs()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    initContactUs(){
      contactUsList().then(res=>{
        console.log(res);
        this.contactUs = res.data
      })
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      this.menuActive = !this.menuActive;
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY;
      this.isFixed = scrollPosition > 50;
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #ffffff;
  transition: all ease 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0);
}

#header.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  animation: slide-down 0.3s;
}

#header.header-fixed .header-top {
  display: none;
}

@keyframes slide-down {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

#header .header-top {
  height: 60px;
  color: #fff;
  font-size: 15px;
  letter-spacing: 0.5px;
  line-height: 60px;
  background: linear-gradient(to right, #2d3e50, #1e73be);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 顶部的图标 */
#header .header-top .info-icon {
  margin: 0 5px;
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-right: 10px;
}

#header .header-top .info-icon i {
  font-size: 14px;
}

/* 头部顶部的链接 */
#header .header-top .shejiao a {
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 15px;
}

#header .header-top .shejiao a:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
  width: 90%;
  transition: height 0.3s ease;
}

.header-fixed .header-nav {
  height: 60px !important;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 260px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 230px;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: all 0.3s ease;
}

.header-fixed .header-nav .header-nav-logo img {
  width: 180px;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 80px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 850px;
  transition: line-height 0.3s ease;
}

.header-fixed .header-nav .header-nav-wrapper {
  line-height: 60px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 25px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #333;
  font-size: 19px;
  font-weight: 500;
  padding: 15px 0;
  position: relative;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  opacity: 0;
  transition: all 0.3s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform 0.3s ease;
  margin-left: 6px;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #1e73be;
  text-decoration: none;
  position: relative;
}

#header .header-nav .header-nav-wrapper>li.active>a:after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #1e73be;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 220px;
  top: 85%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 6px;
  padding: 8px 0;
  opacity: 0;
  transition: opacity 0.3s, top 0.3s;
}

.header-fixed .header-nav .header-nav-wrapper>li>dl {
  top: 60px;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 0;
  border-bottom: none;
}

#header .header-nav .header-nav-wrapper>li>dl>dt>a {
  display: block;
  padding: 12px 20px;
  color: #333;
  font-size: 16px;
  transition: all 0.3s;
  position: relative;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
  color: #1e73be;
  background: rgba(30, 115, 190, 0.05);
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
  opacity: 1;
  top: 100%;
  animation: fadeInUp 0.3s;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate(-50%, 10px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

/* 移动端导航样式 */
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
    background: #fff;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 180px;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 60px;
    font-size: 18px;
    line-height: 60px;
    background: linear-gradient(to right, #2d3e50, #1e73be);
    position: relative;
  }

  /* 汉堡菜单样式 */
  .hamburger {
    width: 35px;
    height: 28px;
    position: relative;
    cursor: pointer;
  }
  
  .hamburger .line {
    display: block;
    width: 100%;
    height: 3px;
    background: #fff;
    position: absolute;
    left: 0;
    border-radius: 3px;
    transition: all 0.3s;
  }
  
  .hamburger .line:nth-child(1) {
    top: 0;
  }
  
  .hamburger .line:nth-child(2) {
    top: 50%;
    transform: translateY(-50%);
  }
  
  .hamburger .line:nth-child(3) {
    bottom: 0;
  }
  
  .hamburger.is-active .line:nth-child(1) {
    transform: translateY(13px) rotate(45deg);
  }
  
  .hamburger.is-active .line:nth-child(2) {
    opacity: 0;
  }
  
  .hamburger.is-active .line:nth-child(3) {
    transform: translateY(-13px) rotate(-45deg);
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -17px;
    width: 35px;
    height: 35px;
    color: #fff;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999999;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 0;
    margin: 0;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: auto;
    line-height: normal;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #333;
    font-size: 17px;
    font-weight: 500;
    padding: 18px;
    display: block;
    position: relative;
    transition: all 0.3s;
  }
  
  #header .header-nav-m .header-nav-m-wrapper>li.active>a {
    color: #1e73be;
    background: rgba(30, 115, 190, 0.05);
  }

  #header .header-nav-m .header-nav-m-wrapper>li>a:hover {
    background: rgba(0, 0, 0, 0.02);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue